import { createFileRoute } from '@tanstack/react-router';
import { TenantContext } from '@interxfi/api-client';
import type { RouteGuardOptions } from '../../../util/routing/guard';

export const Route = createFileRoute('/_app/_platform/_context-required')({
  staticData: {
    guard: { access: { allowedTenantTypes: [TenantContext.Platform, TenantContext.Organization] } },
  } as const satisfies RouteGuardOptions,
  preload: false,
});
